export enum AgGridFilterType {
  number = 'number',
  sql = 'sql',
  set = 'set',
  text = 'text',
  date = 'date',
}
